import { useState } from "react";
import { DateField } from "react-admin";
import { useClientContext } from 'contexts/client';
import DataThruList from "./DataThruList";

import { Tooltip, Button, Typography, useTheme } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";

function getDateWithMostElements(data) {
  const dateCounts = data.reduce((acc, item) => {
    acc[item.max_thru_date] = (acc[item.max_thru_date] || 0) + 1;
    return acc;
  }, {});

  let maxCount = 0;
  let dateWithMaxElements = null;

  Object.entries(dateCounts).forEach(([date, count]) => {
    if (count > maxCount) {
      maxCount = count;
      dateWithMaxElements = date;
    }
  });
  if (process.env.NODE_ENV === 'development') {
    // console.log('dateWithMaxElements', dateWithMaxElements, data[0]);
  }
  return dateWithMaxElements;
}

export const DataThruIcon = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { state: client } = useClientContext();
  const theme = useTheme();
  
  // Support props for testing or use client context data
  const dataThru = props.data || client?.client?.dataThruByWarehouse;
 
  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  // Support children render prop pattern for testing
  const renderChildren = () => {
    if (props.children && typeof props.children === 'function' && props.data) {
      return props.children(props.data);
    }
    return null;
  };

  // Add data-testid for testing
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        placement="bottom"
        PopperProps={{
          disablePortal: true,
        }}
        onClose={handleTooltipClose}
        open={props.tooltip ? true : tooltipOpen} // Always show tooltip if tooltip prop is provided
        disableFocusListener
        disableHoverListener
        disableTouchListener
        sx={{
          maxWidth: 800,
          fontSize: theme.typography.pxToRem(12),
        }}
        title={
          props.tooltip || (
            <div>
              <Typography variant="subtitle1" color="inherit" gutterBottom>
                Data Through By Warehouse 
              </Typography>
              {dataThru ? <DataThruList data={dataThru} /> : null}
            </div>
          )
        }
      >
        <Button 
          variant="text" 
          size="small" 
          onClick={props.onClick || ((e) => setTooltipOpen(!tooltipOpen))}
          style={props.style}
          data-testid="data-thru-icon"
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'lightGrey' }}>
            <span style={{ fontWeight: 'bold' }}>Data Through</span>
            {!props.children && (
              <DateField
                record={{ "max_thru_date" : dataThru ? getDateWithMostElements(dataThru) : null }}
                source="max_thru_date"
                locales="en-US"
                options={{ timeZone: 'UTC' }}
              />
            )}
            {renderChildren()}
          </div>
        </Button>
      </Tooltip>
    </ClickAwayListener>
  );
};

// Add default export
export default DataThruIcon;
